/***
*
*   SIGN UP STEP 2
*   Signup form for account owners
*   Step 1: create account
*   Step 2: verify email address
*   Step 3: select plan
*
**********/

import React, { useContext, useState, useEffect } from 'react';
import { Animate, AuthContext, Row, Card, Form, usePlans, Link, useNavigate, Event, Message } from 'components/lib';

export function SignupPlan(props) {

  const context = useContext(AuthContext);
  const navigate = useNavigate();
  const plans = usePlans();
  const plan = window.location.hash.substring(1);
  const [selectPlan, setSelectedPlan] = useState('');
  const [showMessage, setShowMessage] = useState(false)

  useEffect(() => {

    if (selectPlan) {

      const planned = plans.data.list.find(item => item.value === selectPlan)
      if (planned?.enterprise) {
        setShowMessage(true)
      } else {
        setShowMessage(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectPlan])

  if (!plans.data)
    return false;

  const message = props.t('auth.signup.plan.message.text')
  return (
    <Animate type='pop'>
      <Row title={props.t('auth.signup.plan.title')}>
        {
          showMessage &&
          <Message
            title={props.t('auth.signup.plan.message.title')}
            text={message}
            type='info'
            closable={true}
          />
        }
        <Card loading={false} restrictWidth center>

          <Form
            inputs={{
              plan: {
                label: props.t('auth.signup.plan.form.plan.label'),
                type: 'select',
                options: plans?.data?.list?.filter(item => item.show),
                default: plan,
                required: true,
              }
            }}
            url='/api/account/plan'
            setSelectedPlan={setSelectedPlan}
            method='POST'
            buttonText={props.t('auth.signup.plan.form.button')}
            callback={res => {

              // save the plan to context, then redirect
              if (res.data?.checkout_url) {
                window.location.href = res.data?.checkout_url
                // Event('selected_plan', { plan: res.data.plan });
                // context.update({ plan: res.data.plan, subscription: res.data.subscription, permission: res.data.permission });

              } else if (res.data.plan === 'free' || res.data.plan === 'hybrid') {
                Event('selected_plan', { plan: res.data.plan });
                context.update({ plan: res.data.plan, subscription: res.data.subscription, permission: res.data.permission });
                navigate('/navigate');
              }
            }}
          />

          <div className='mt-4'>
            <Link url='/account/profile' text={props.t('auth.signup.plan.footer.link.manage')} />
          </div>
          <div className='mt-4' onClick={() => { context.signout() }}>
            <Link text={props.t('auth.signup.plan.footer.link.signOut')} />
          </div>

        </Card>
      </Row>
    </Animate>
  );
}
